export const MAX_VALUE_INPUT_LIMITER = 999999999;
